import React, { useContext, useEffect, useMemo, useRef, useState } from "react";
import { Input, Modal, Popover, Image } from "antd";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { getRequest } from "../../api/http";
import userapiservice from "../../api/userapiservice";
import { GlobalContext } from "../../components/globalContext/GlobalContext";
import { CloseActive, SearchZoomActive } from "../../components/Icons/Icons";
import ToastComponent from "../../components/ToastCompoent/ToastComponent";
import usePartnerName from "../../hooks/usePartnerName";
import location_red_new from "../../assets/newImages/browse_icon.png";
import {
  setOrganisationType as localStorageSetOrganisationType,
  setSize as localStorageSetSize,
  setInterestAndAssetType,
  setPage,
  setPartner,
  setSearchName,
  setSector,
  setState,
  setSubSector,
  setTabValue,
  updateCountry,
  updateCounty,
  setPartnerId as updatePartnerId,
  updateOrganisationNameById,
  setCountry,
  setOrganisationTypeLabel,
  setPartnerType,
} from "../../Reducer/localStorageSlice";
import { handleErrorMessage } from "../../utils/helper";
import { typeOfDevice } from "../../utils/util";
import "../partnerScreen/PartnerPage.scss";
import "../partnerScreen/VerticalLogoSlider.scss";
import PartnerCarousel from "../partnerScreen/partnerSlider";
import { inputFieldCharLimit } from "../../config";
import { setPartnerData } from "../../Reducer/globalSlice";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, FreeMode } from "swiper/modules";
import "swiper/css";
import { useMediaQuery } from "react-responsive";
import VerticalLogoSlider from "../partnerScreen/VerticalLogoSlider";
import FilterNew from "./FilterNew";

const HorizontalLogoCarousel = ({ partnerLogos, type, partnerDetails }) => {
  const swiperRef = useRef(null);
  const { globalState } = useContext(GlobalContext);

  const extendedPartnerLogos = useMemo(() => {
    return [...partnerLogos, ...partnerLogos];
  }, [partnerLogos]);

  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === "visible") {
        const swiper = swiperRef.current;
        if (swiper) {
          swiper.autoplay.stop();
          swiper.update();
          swiper.slideToLoop(swiper.realIndex, 0);
          swiper.autoplay.start();
        }
      }
    };
    document.addEventListener("visibilitychange", handleVisibilityChange);
    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, []);

  return (
    <div className="w-100 business-partners-carousel-container">
      <div
        className="d-flex align-items-center justify-content-center"
        style={{ margin: "10px 0" }}
      >
        <strong className="our-business-partners-header">
          {partnerDetails?.partnerSponsorsSliderTitle ??
            "Our Business Partners"}
        </strong>
      </div>
      <div className="swiper-container">
        <Swiper
          modules={[Autoplay, FreeMode]}
          slidesPerView="auto"
          loop={true}
          grabCursor={true}
          freeModeMomentum={false}
          autoplay={{
            delay: 0,
            disableOnInteraction: false,
            pauseOnMouseEnter: false,
          }}
          speed={4000}
        >
          {extendedPartnerLogos?.map((logo, index) => (
            <SwiperSlide key={index} className="swiper-slide-container">
              <div
                className="logo-box"
                onClick={(e) => {
                  e.stopPropagation();
                  const url = logo?.urlLink?.startsWith("https://")
                    ? logo?.urlLink
                    : `https://${logo?.urlLink}`;
                  window.open(url, "_blank", "noopener,noreferrer");
                  setTimeout(() => {
                    const swiper = swiperRef.current;
                    if (swiper) {
                      swiper.autoplay.stop();
                      swiper.autoplay.start();
                    }
                  }, 200);
                }}
              >
                <img
                  src={logo?.mediaLink?.url}
                  alt={`logo-${index}`}
                  className="swiper-partners-logos-images"
                />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
};

export default function PartnerPageNew() {
  const dispatch = useDispatch();
  const localData = useSelector((state) => state?.localStorage);
  const { partnerId: persistPartnerId } = localData;
  const isMobile = useMediaQuery({ maxWidth: 767 });
  const type = typeOfDevice();
  const { globalState, setGlobalState } = useContext(GlobalContext);
  const { formattedName: partner } = usePartnerName();
  const navigate = useNavigate();

  const [partnerLogos, setPartnerLogos] = useState([]);
  const [latitude, setLatitude] = useState(null);
  const [longitude, setLongitude] = useState(null);
  const [partnerLogo, setPartnerLogo] = useState(null);
  const [partnerCarousel, setPartnerCarousel] = useState(null);
  const [loading, setLoading] = useState(false);
  const [SearchKeyWord, setSearchKeyWord] = useState("");
  const [partnerId, setPartnerId] = useState(persistPartnerId);
  const [openHome, setOpenHome] = useState(false);

  const getPartnersLogo = async (partnerName) => {
    try {
      const response = await getRequest(
        userapiservice.getPartnerSupporterLogo(partnerName),
      );
      if (response) {
        setPartnerLogos(response);
      }
    } catch (error) {
      toast.error(
        <ToastComponent
          type={"Error"}
          message={handleErrorMessage(error, "Failed to fetch Partner logos")}
        />,
      );
    }
  };

  const handleFreeTextChange = (e) => {
    setSearchKeyWord(e.target.value);
    dispatch(setSearchName(e.target.value));
  };

  const clearSearchKeyword = () => {
    setSearchKeyWord("");
    dispatch(setSearchName(""));
  };

  const getPartnerLogo = async (partner) => {
    try {
      const response = await getRequest(
        userapiservice.getPartnerDetails(partner),
      );
      if (response) {
        setPartnerLogo(response);
        setPartnerId(response.id);
        dispatch(updatePartnerId(response?.id));
        dispatch(setPartnerData(response));
      }
    } catch (e) {
      Modal.error({
        title: "Error",
        content: e.response?.data?.message || "Something went wrong...",
      });
    }
  };

  const getPartnerCarousel = async (partner) => {
    setLoading(false);
    try {
      const response = await getRequest(
        userapiservice.getPartnerCarousel(partner),
      );
      if (response?.length > 1) {
        const data = [...response];
        const main = data?.find((item) => item?.mainCarousel);
        const others = data?.filter((item) => !item?.mainCarousel);
        const sortedData = [...others]?.sort(
          (a, b) => (a?.order ?? 0) - (b?.order ?? 0),
        );
        const updatedData = main ? [main, ...sortedData] : sortedData;
        const firstItem = updatedData?.shift();
        updatedData?.splice(1, 0, firstItem);
        setPartnerCarousel(updatedData);
      } else {
        setPartnerCarousel(response);
      }
      setLoading(true);
    } catch (e) {
      setLoading(false);
      Modal.error({
        title: "Error",
        content: e.response?.data?.message || "Something went wrong...",
      });
    }
  };

  const searchClick = () => {
    setOpenHome(true);
  };

  const handleFilterApply = (values) => {
    dispatch(setPartnerType({ checked: values.partnerTypeChecked }));
    dispatch(localStorageSetOrganisationType(values.organisationTypeId));
    dispatch(setOrganisationTypeLabel(values.organisationTypeLabel));
    dispatch(updateOrganisationNameById(values.organisationTypeLabel));
    dispatch(setInterestAndAssetType(values.interest));
    dispatch(setSector(values.sectorId));
    dispatch(setSubSector(values.subSectorId));
    dispatch(localStorageSetSize(values.sizeId));
    dispatch(setTabValue(values.interest));
    dispatch(setSearchName(SearchKeyWord));
    setOpenHome(true);
  };

  const searchHandleKeyDown = (e) => {
    if (e.key === "Enter") {
      searchClick(e);
    }
  };

  useEffect(() => {
    if (globalState.partner !== partner) {
      setGlobalState((prevState) => ({ ...prevState, partner }));
    }
    if (globalState.partnerId !== partnerId) {
      setGlobalState((prevState) => ({ ...prevState, partnerId }));
    }
  }, [partner, partnerId]);

  useEffect(() => {
    dispatch(setPartner(partner));
  }, [partner]);

  const getCountryFromCoords = async (lat, lng) => {
    const res = await fetch(
      `https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lng}`,
    );
    const data = await res.json();
    return data.address.country;
  };

  useEffect(() => {
    navigator.geolocation.getCurrentPosition(async (pos) => {
      const { latitude, longitude } = pos.coords;
      const country = await getCountryFromCoords(latitude, longitude);
      dispatch(setCountry(country));
      localStorage.setItem("country", country);
    });
  }, []);

  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          setLatitude(position.coords.latitude);
          setLongitude(position.coords.longitude);
        },
        (error) => {
          console.error(error);
        },
      );
    } else {
      console.error("Geolocation is not supported by this browser.");
    }
  }, []);

  useEffect(() => {
    if (latitude && longitude) {
      async function getWeather() {
        let res = await axios.get(
          `https://nominatim.openstreetmap.org/reverse?format=geojson&zoom=8&lat=${latitude}&lon=${longitude}`,
        );
        dispatch(
          updateCountry(res.data?.features[0]?.properties?.address?.country),
        );
        dispatch(
          setCountry(res.data?.features[0]?.properties?.address?.country),
        );
        if (res.data?.features[0]?.properties?.address?.county) {
          dispatch(
            updateCounty(res.data?.features[0]?.properties?.address?.county),
          );
        } else if (res.data?.features[0]?.properties?.address?.state_district) {
          dispatch(
            updateCounty(
              res.data?.features[0]?.properties?.address?.state_district,
            ),
          );
        } else if (res.data?.features[0]?.properties?.address?.municipality) {
          dispatch(
            updateCounty(
              res.data?.features[0]?.properties?.address?.municipality,
            ),
          );
        } else if (res.data?.features[0]?.properties?.address?.town) {
          dispatch(
            updateCounty(res.data?.features[0]?.properties?.address?.town),
          );
        } else {
          dispatch(
            updateCounty(res.data?.features[0]?.properties?.address?.city),
          );
        }
        dispatch(setState(res.data?.features[0]?.properties?.address?.state));
      }
      getWeather();
    }
  }, [latitude, longitude]);

  useEffect(() => {
    if (partner) {
      getPartnersLogo(partner);
    }
  }, [partner]);

  useEffect(() => {
    if (openHome) {
      navigate("/microsite");
    }
    setOpenHome(false);
  }, [openHome]);

  useEffect(() => {
    if (partner) {
      getPartnerLogo(partner);
      getPartnerCarousel(partner);
    }
  }, [partner]);

  useEffect(() => {
    dispatch(setPage("partner"));
  }, [partner, partnerId]);

  return (
    <div
      className={`main-body-container d-flex flex-column ${
        globalState.isMobile
          ? "body-container-mobile bg-white"
          : "body-container-desktop"
      }`}
      style={{
        backgroundImage: `${
          partnerLogo?.wallpaperToggle === true && !globalState.isMobile
            ? `url(${partnerLogo?.wallpaper})`
            : `none`
        }`,
        backgroundColor: `${
          partnerLogo?.wallpaperToggle === true && !globalState.isMobile
            ? `none`
            : "#F6F6F6"
        }`,
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
      }}
    >
      <div
        className={`main-body ${
          globalState.isMobile ? "body-mobile" : "body-desktop"
        }`}
      >
        <div className="partner-page-container">
          <h3 className="partner-page-org-title">{partnerLogo?.siteName}</h3>

          {loading && (
            <div
              className={`partner-page-carousel ${
                !globalState.isMobile ? "bordered-container" : ""
              } bg-white`}
            >
              <PartnerCarousel carouselData={partnerCarousel} />
            </div>
          )}

          {loading && (
            <>
              <div
                className={`partner-page-logos-and-search ${
                  globalState.isMobile ? "my-0 " : "bordered-container"
                } align-items-center bg-white ${
                  partnerLogos?.length < 5
                    ? "partner-page-logos-and-search-flex-grow-0"
                    : ""
                }`}
              >
                <div
                  className={`d-flex search-wrapper ${
                    globalState.isMobile ? "w-100 p-0" : "w-md-75"
                  }`}
                >
                  <div
                    className="title-bar-search-wrapper"
                    style={{ width: "100%" }}
                  >
                    <div className="search-engin-wrapper">
                      <Link to="/microsite" title="Browse Organisations">
                        <Image
                          preview={false}
                          src={location_red_new}
                          className="searchEngineIcon"
                        />
                      </Link>
                    </div>
                    <Input
                      onChange={handleFreeTextChange}
                      placeholder="Search for Businesses"
                      className="h-100 w-100 main-search"
                      onKeyDown={searchHandleKeyDown}
                      value={SearchKeyWord}
                      maxLength={inputFieldCharLimit}
                      prefix={
                        <span className="d-flex align-items-center gap-1">
                          <SearchZoomActive customClassName="search-icon-landing-page" />
                        </span>
                      }
                      suffix={
                        <span className="align-items-center d-flex gap-1">
                          {SearchKeyWord.length > 0 && (
                            <button
                              onClick={() => clearSearchKeyword()}
                              className="btn btn-sm"
                            >
                              <CloseActive />
                            </button>
                          )}
                          <FilterNew onApply={handleFilterApply} />
                        </span>
                      }
                    />
                  </div>
                </div>

                {isMobile ? (
                  <VerticalLogoSlider
                    partnerLogos={partnerLogos}
                    type={type}
                    partnerDetails={partnerLogo}
                  />
                ) : (
                  <div
                    className={`d-flex partners-logo-carousel ${
                      partnerLogos?.length < 5
                        ? "partners-logo-carousel-height-unset"
                        : ""
                    }`}
                  >
                    <HorizontalLogoCarousel
                      partnerLogos={partnerLogos}
                      type={type}
                      partnerDetails={partnerLogo}
                    />
                  </div>
                )}
              </div>
            </>
          )}

          {loading && (
            <div
              className={`partner-page-join-now bordered-container bg-white d-flex ${
                globalState?.isMobile && partnerLogos?.length === 0
                  ? "empty-vertical-data"
                  : ""
              }`}
            >
              <div className="partner-org-logo-container">
                <img
                  src={partnerLogo?.mediaLink}
                  className="partner-org-logo"
                  alt="logo"
                />
              </div>
              <p className="description">
                <Popover
                  content={
                    <div style={{ maxWidth: 300 }}>
                      {partnerLogo?.endUserPageDescription}
                    </div>
                  }
                  placement="topLeft"
                  trigger={globalState.isMobile ? "click" : ["hover", "focus"]}
                  overlayClassName="partner-description-tooltip"
                >
                  <span
                    className="description-text"
                    role="button"
                    tabIndex={0}
                    aria-label={partnerLogo?.endUserPageDescription}
                  >
                    {partnerLogo?.endUserPageDescription}
                  </span>
                </Popover>
              </p>
              <a
                href={partnerLogo?.website}
                target="_blank"
                rel="noreferrer"
                className={`btn join-now-btn btn-primary text-white ${
                  globalState.isMobile ? "btn-sm" : "btn-block"
                } ${partnerLogo?.website ? "" : "disabled"}`}
              >
                Find Out More
              </a>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
